/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-28 15:40:04
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-03-28 15:40:39
 * @FilePath: src/store/modules/settings.ts
 * @Description: TypeScript版本 - 自动转换
 */

import { defineStore } from 'pinia'

import defaultSettings from '@/settings'
import { readAppearance, applyAppearance } from '@/utils/appearance'
import { useDynamicTitle } from '@/utils/dynamicTitle'

const appearance = readAppearance()
applyAppearance(appearance)

const { showSettings, topNav, tagsView, fixedHeader, sidebarLogo, dynamicTitle } = defaultSettings

const storageSetting = (() => {
  try { const value = JSON.parse(localStorage.getItem('layout-setting') || '{}'); return value && typeof value === 'object' ? value : {} } catch { return {} }
})()
const DOMI_PRIMARY = '#FA8C16'


const useSettingsStore = defineStore('settings', {
  state: (): any => ({
    title: '',
    theme: appearance === 'dark' ? '#D87A16' : DOMI_PRIMARY,
    sideTheme: 'theme-light',
    showSettings: showSettings,
    topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
    tagsView: false, // The visited-page strip is retired, including saved preferences.
    fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
    sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
    dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle,
    isDark: appearance === 'dark',
  }),
  actions: {
    // 修改布局设置
    changeSetting(data: SettingData): void {
      const { key, value } = data
      if (Object.prototype.hasOwnProperty.call(this, key)) {
        ;(this as any)[key] = value
      }
    },
    // 设置网页标题
    setTitle(title: any): void {
      this.title = title
      useDynamicTitle()
    },
    setAppearance(dark: boolean): void {
      this.isDark = dark
      this.theme = dark ? '#D87A16' : DOMI_PRIMARY
      applyAppearance(dark ? 'dark' : 'light')
    },
    // 切换暗黑模式
    toggleTheme(): void {
      this.setAppearance(!this.isDark)
    },
  },
})

export default useSettingsStore
